import React from 'react';
import './cursorIndicator.style.scss';

interface CursorIndicatorProps {
  size: number;
  isEraser?: boolean;
  position: { x: number; y: number };
  visible: boolean;
}

const CursorIndicator: React.FC<CursorIndicatorProps> = ({
  size,
  position,
  visible
}) => {
  if (!visible) return null;

  return (
    <div
      className="cursor-indicator"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        width: `${size}px`,
        height: `${size}px`,
        borderWidth: '2px',
        transform: `translate(-50%, -50%)`,
        position: 'absolute',
      }}
    />
  );
};

export default CursorIndicator; 